module.exports = __webpack_public_path__ + "img/logo.a31ee600.svg";